export default "__VITE_ASSET__CQLRhNHh__"